import { TrainingPackage } from '../config/Registration';

export const isTrainingPackageActive = (
  trainingPackage?: TrainingPackage,
  now: Date = new Date()
): boolean => {
  if (!trainingPackage?.isActive || !trainingPackage.endDate) {
    return false;
  }

  return new Date(trainingPackage.endDate).getTime() > now.getTime();
};

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const getExpiringPackageDays = (
  trainingPackage: TrainingPackage | undefined,
  thresholdDays: number,
  now: Date = new Date()
): number | null => {
  if (!isTrainingPackageActive(trainingPackage, now) || thresholdDays <= 0) {
    return null;
  }

  const millisecondsUntilExpiration = new Date(trainingPackage.endDate).getTime() - now.getTime();
  if (millisecondsUntilExpiration >= thresholdDays * MILLISECONDS_PER_DAY) {
    return null;
  }

  return Math.max(1, Math.ceil(millisecondsUntilExpiration / MILLISECONDS_PER_DAY));
};
